import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './ui/FadeIn';
import { CTAButton } from './ui/CTAButton';
import { FloatingElements } from './ui/FloatingElements';
import { ChevronDownIcon } from 'lucide-react';
export function HeroSection() {
  const titleWords = 'Hay un vacío silencioso en tu cama que ninguna "noche de cita" ha podido llenar... todavía.'.split(' ');
  return <section id="hero" className="relative min-h-screen flex flex-col items-center justify-center py-24 px-4 md:px-8 overflow-hidden" data-id="element-124">
      {/* Background Image */}
      <img src="https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?w=1400&q=80" alt="Pareja en un momento íntimo y cálido" className="absolute inset-0 w-full h-full object-cover object-center z-0" data-id="element-125" />
      {/* Warm Cream Overlay */}
      <div className="absolute inset-0 bg-cream/85 z-[1]" data-id="element-126"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-cream/40 via-transparent to-cream/60 z-[2]" data-id="element-127"></div>

      {/* Cinematic Grain Overlay */}
      <div className="absolute inset-0 bg-noise opacity-[0.04] pointer-events-none z-[3] mix-blend-multiply" data-id="element-128"></div>

      <FloatingElements count={8} data-id="element-129" />

      <div className="max-w-4xl mx-auto text-center relative z-20 mt-12" data-id="element-130">
        <FadeIn data-id="element-131">
          <motion.div initial={{
          width: 0
        }} animate={{
          width: 64
        }} transition={{
          duration: 1.5,
          ease: 'easeOut',
          delay: 0.5
        }} className="h-[1px] bg-gold mx-auto mb-10" data-id="element-132" />
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-burgundy-dark leading-[1.25] md:leading-[1.25] mb-10" data-id="element-133">
            {titleWords.map((word, i) => <motion.span key={i} initial={{
            opacity: 0,
            y: 20,
            filter: 'blur(8px)'
          }} animate={{
            opacity: 1,
            y: 0,
            filter: 'blur(0px)'
          }} transition={{
            duration: 0.8,
            delay: i * 0.08 + 0.2,
            ease: [0.21, 0.47, 0.32, 0.98]
          }} className="inline-block mr-[0.25em]" data-id="element-134">
                {word}
              </motion.span>)}
          </h1>
        </FadeIn>

        <FadeIn delay={1.2} data-id="element-135">
          <h2 className="text-lg md:text-xl lg:text-2xl text-charcoal-light font-sans max-w-3xl mx-auto leading-relaxed mb-16 opacity-90" data-id="element-136">
            Descubre los 7 síntomas ocultos que están apagando tu chispa
            femenina y aprende cómo recuperar la conexión emocional y el deseo
            en tu matrimonio en solo 7 días.
          </h2>
        </FadeIn>

        <FadeIn delay={1.6} className="max-w-2xl mx-auto text-left space-y-8 text-lg md:text-xl text-charcoal leading-[1.8]" data-id="element-137">
          <p data-id="element-138">
            Entras a la habitación y el silencio pesa más que el cansancio.
            Miras a tu esposo y, aunque lo amas, sientes que un muro invisible
            de mil kilómetros los separa. Te preguntas:{' '}
            <em className="font-serif text-burgundy text-xl md:text-2xl text-glow block mt-4 text-center" data-id="element-139">
              ¿En qué momento dejamos de ser amantes para convertirnos en
              simples socios logísticos?
            </em>
          </p>
          <p data-id="element-140">
            No hubo una gran pelea. No hubo una traición. Simplemente, la luz se
            fue atenuando entre las tareas de los hijos, las cuentas por pagar y
            la rutina infinita. Te sientes sola estando acompañada, y ese vacío
            en el pecho te dice que mereces más que una relación "estable" pero
            fría.
          </p>
        </FadeIn>

        <FadeIn delay={2} className="mt-16" data-id="element-141">
          <CTAButton data-id="element-142" />
        </FadeIn>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 3,
      duration: 1
    }} className="absolute bottom-8 left-1/2 -translate-x-1/2 z-20 text-gold" data-id="element-143">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-144">
          <ChevronDownIcon className="w-8 h-8 opacity-60" data-id="element-145" />
        </motion.div>
      </motion.div>
    </section>;
}